var cov_8rcduwepr = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/styles/index.js",
      hash = "0e675e5c957ff79b5be183b29ab9fb5a0b84db20",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var selectLess = {};
import genaration from '../../utils/classname';
export var selectClass = (cov_8rcduwepr.s[0]++, genaration(selectLess, 'select'));